// This file is auto-generated by build-artifacts.ts
import { type MockArtifact } from './types';

export const MockTaskManagerArtifact = {
  contractName: 'MockTaskManager',
  isFixed: true,
  fixedAddress: '0xeA30c4B8b44078Bbf8a6ef5b9f1eC1626C7848D9',
  abi: [
    {
      type: 'constructor',
      inputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'MOCK_logAllow',
      inputs: [
        {
          name: 'operation',
          type: 'string',
          internalType: 'string',
        },
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'MOCK_setInEuintKey',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'value',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'acl',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'address',
          internalType: 'contract MockACL',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'aggregator',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'address',
          internalType: 'address',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'allow',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'allowForDecryption',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'allowGlobal',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'allowTransient',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'createDecryptTask',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: '',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'createRandomTask',
      inputs: [
        {
          name: 'returnType',
          type: 'uint8',
          internalType: 'uint8',
        },
        {
          name: 'seed',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'securityZone',
          type: 'int32',
          internalType: 'int32',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'createTask',
      inputs: [
        {
          name: 'returnType',
          type: 'uint8',
          internalType: 'uint8',
        },
        {
          name: 'funcId',
          type: 'uint8',
          internalType: 'enum FunctionId',
        },
        {
          name: 'encryptedHashes',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
        {
          name: 'extraInputs',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'decryptResultSigner',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'address',
          internalType: 'address',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'exists',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'pure',
    },
    {
      type: 'function',
      name: 'getDecryptResult',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'getDecryptResultSafe',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: 'result',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'decrypted',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'handleDecryptResult',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'result',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: '',
          type: 'address[]',
          internalType: 'address[]',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'handleError',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'operation',
          type: 'string',
          internalType: 'string',
        },
        {
          name: 'errorMessage',
          type: 'string',
          internalType: 'string',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'inMockStorage',
      inputs: [
        {
          name: '',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'initialize',
      inputs: [
        {
          name: 'initialOwner',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'isAllowed',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'isAllowedWithPermission',
      inputs: [
        {
          name: 'permission',
          type: 'tuple',
          internalType: 'struct Permission',
          components: [
            {
              name: 'issuer',
              type: 'address',
              internalType: 'address',
            },
            {
              name: 'expiration',
              type: 'uint64',
              internalType: 'uint64',
            },
            {
              name: 'recipient',
              type: 'address',
              internalType: 'address',
            },
            {
              name: 'validatorId',
              type: 'uint256',
              internalType: 'uint256',
            },
            {
              name: 'validatorContract',
              type: 'address',
              internalType: 'address',
            },
            {
              name: 'sealingKey',
              type: 'bytes32',
              internalType: 'bytes32',
            },
            {
              name: 'issuerSignature',
              type: 'bytes',
              internalType: 'bytes',
            },
            {
              name: 'recipientSignature',
              type: 'bytes',
              internalType: 'bytes',
            },
          ],
        },
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'isInitialized',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'isPubliclyAllowed',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'logOps',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'mockStorage',
      inputs: [
        {
          name: '',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'publishDecryptResult',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'result',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'signature',
          type: 'bytes',
          internalType: 'bytes',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'publishDecryptResultBatch',
      inputs: [
        {
          name: 'ctHashes',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
        {
          name: 'results',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
        {
          name: 'signatures',
          type: 'bytes[]',
          internalType: 'bytes[]',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'removeFirstLetter',
      inputs: [
        {
          name: 'str',
          type: 'string',
          internalType: 'string',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'string',
          internalType: 'string',
        },
      ],
      stateMutability: 'pure',
    },
    {
      type: 'function',
      name: 'setACLContract',
      inputs: [
        {
          name: '_aclAddress',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'setAggregator',
      inputs: [
        {
          name: '_aggregatorAddress',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'setDecryptResultSigner',
      inputs: [
        {
          name: 'signer',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'setLogOps',
      inputs: [
        {
          name: '_logOps',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'setSecurityZoneMax',
      inputs: [
        {
          name: 'securityZone',
          type: 'int32',
          internalType: 'int32',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'setSecurityZoneMin',
      inputs: [
        {
          name: 'securityZone',
          type: 'int32',
          internalType: 'int32',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'setSecurityZones',
      inputs: [
        {
          name: 'minSZ',
          type: 'int32',
          internalType: 'int32',
        },
        {
          name: 'maxSZ',
          type: 'int32',
          internalType: 'int32',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'setVerifierSigner',
      inputs: [
        {
          name: 'signer',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'sliceString',
      inputs: [
        {
          name: 'str',
          type: 'string',
          internalType: 'string',
        },
        {
          name: 'start',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'length',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'string',
          internalType: 'string',
        },
      ],
      stateMutability: 'pure',
    },
    {
      type: 'function',
      name: 'verifyDecryptResult',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'result',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'signature',
          type: 'bytes',
          internalType: 'bytes',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'verifyDecryptResultBatch',
      inputs: [
        {
          name: 'ctHashes',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
        {
          name: 'results',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
        {
          name: 'signatures',
          type: 'bytes[]',
          internalType: 'bytes[]',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'verifyDecryptResultBatchSafe',
      inputs: [
        {
          name: 'ctHashes',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
        {
          name: 'results',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
        {
          name: 'signatures',
          type: 'bytes[]',
          internalType: 'bytes[]',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool[]',
          internalType: 'bool[]',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'verifyDecryptResultSafe',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'result',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'signature',
          type: 'bytes',
          internalType: 'bytes',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'verifyInput',
      inputs: [
        {
          name: 'input',
          type: 'tuple',
          internalType: 'struct EncryptedInput',
          components: [
            {
              name: 'ctHash',
              type: 'uint256',
              internalType: 'uint256',
            },
            {
              name: 'securityZone',
              type: 'uint8',
              internalType: 'uint8',
            },
            {
              name: 'utype',
              type: 'uint8',
              internalType: 'uint8',
            },
            {
              name: 'signature',
              type: 'bytes',
              internalType: 'bytes',
            },
          ],
        },
        {
          name: 'sender',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      stateMutability: 'nonpayable',
    },
    {
      type: 'event',
      name: 'DecryptionResult',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          indexed: false,
          internalType: 'uint256',
        },
        {
          name: 'result',
          type: 'uint256',
          indexed: false,
          internalType: 'uint256',
        },
        {
          name: 'requestor',
          type: 'address',
          indexed: true,
          internalType: 'address',
        },
      ],
      anonymous: false,
    },
    {
      type: 'event',
      name: 'ProtocolNotification',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          indexed: false,
          internalType: 'uint256',
        },
        {
          name: 'operation',
          type: 'string',
          indexed: false,
          internalType: 'string',
        },
        {
          name: 'errorMessage',
          type: 'string',
          indexed: false,
          internalType: 'string',
        },
      ],
      anonymous: false,
    },
    {
      type: 'event',
      name: 'TaskCreated',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          indexed: false,
          internalType: 'uint256',
        },
        {
          name: 'operation',
          type: 'string',
          indexed: false,
          internalType: 'string',
        },
        {
          name: 'input1',
          type: 'uint256',
          indexed: false,
          internalType: 'uint256',
        },
        {
          name: 'input2',
          type: 'uint256',
          indexed: false,
          internalType: 'uint256',
        },
        {
          name: 'input3',
          type: 'uint256',
          indexed: false,
          internalType: 'uint256',
        },
      ],
      anonymous: false,
    },
    {
      type: 'error',
      name: 'ACLNotAllowed',
      inputs: [
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
      ],
    },
    {
      type: 'error',
      name: 'DecryptionResultNotReady',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
    },
    {
      type: 'error',
      name: 'ECDSAInvalidSignature',
      inputs: [],
    },
    {
      type: 'error',
      name: 'ECDSAInvalidSignatureLength',
      inputs: [
        {
          name: 'length',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
    },
    {
      type: 'error',
      name: 'ECDSAInvalidSignatureS',
      inputs: [
        {
          name: 's',
          type: 'bytes32',
          internalType: 'bytes32',
        },
      ],
    },
    {
      type: 'error',
      name: 'InputNotInMockStorage',
      inputs: [
        {
          name: 'ctHash',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidAddress',
      inputs: [],
    },
    {
      type: 'error',
      name: 'InvalidInputForFunction',
      inputs: [
        {
          name: 'functionName',
          type: 'string',
          internalType: 'string',
        },
        {
          name: 'inputType',
          type: 'uint8',
          internalType: 'uint8',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidInputType',
      inputs: [
        {
          name: 'actual',
          type: 'uint8',
          internalType: 'uint8',
        },
        {
          name: 'expected',
          type: 'uint8',
          internalType: 'uint8',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidInputsAmount',
      inputs: [
        {
          name: 'operation',
          type: 'string',
          internalType: 'string',
        },
        {
          name: 'got',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'expected',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidOperationInputs',
      inputs: [
        {
          name: 'operation',
          type: 'string',
          internalType: 'string',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidSecurityZone',
      inputs: [
        {
          name: 'zone',
          type: 'int32',
          internalType: 'int32',
        },
        {
          name: 'min',
          type: 'int32',
          internalType: 'int32',
        },
        {
          name: 'max',
          type: 'int32',
          internalType: 'int32',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidSignature',
      inputs: [],
    },
    {
      type: 'error',
      name: 'InvalidSigner',
      inputs: [
        {
          name: 'signer',
          type: 'address',
          internalType: 'address',
        },
        {
          name: 'expectedSigner',
          type: 'address',
          internalType: 'address',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidThreeInputOperation',
      inputs: [
        {
          name: 'operation',
          type: 'string',
          internalType: 'string',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidTwoInputOperation',
      inputs: [
        {
          name: 'operation',
          type: 'string',
          internalType: 'string',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidTypeOrSecurityZone',
      inputs: [
        {
          name: 'operation',
          type: 'string',
          internalType: 'string',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidUnaryOperation',
      inputs: [
        {
          name: 'operation',
          type: 'string',
          internalType: 'string',
        },
      ],
    },
    {
      type: 'error',
      name: 'NotImplemented',
      inputs: [],
    },
    {
      type: 'error',
      name: 'OnlyAggregatorAllowed',
      inputs: [
        {
          name: 'caller',
          type: 'address',
          internalType: 'address',
        },
      ],
    },
    {
      type: 'error',
      name: 'OnlyOwnerAllowed',
      inputs: [
        {
          name: 'caller',
          type: 'address',
          internalType: 'address',
        },
      ],
    },
    {
      type: 'error',
      name: 'RandomFunctionNotSupported',
      inputs: [],
    },
    {
      type: 'error',
      name: 'StringsInsufficientHexLength',
      inputs: [
        {
          name: 'value',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'length',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
    },
    {
      type: 'error',
      name: 'TooManyInputs',
      inputs: [
        {
          name: 'operation',
          type: 'string',
          internalType: 'string',
        },
        {
          name: 'got',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'maxAllowed',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
    },
  ],
} as const satisfies MockArtifact;
